"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.salePaymentFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.salePaymentFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uuid: Factory.each(i => uuid_1.v4()),
    amount: Mocks.clare.amountTen,
    original_amount: Mocks.clare.amountTen,
    amount_adjusted: Mocks.clare.amountTen,
    status_display: Mocks.clare.statusSettled,
    status: 'paid',
    sale_number: Mocks.clare.saleNumber,
    sale_id: Mocks.clare.saleId,
    acct_type: Mocks.clare.acctType,
    acct_num: Mocks.clare.acctNum,
    acct_type_display: Mocks.clare.acctTypeDisplay,
    created_at: Mocks.dates.date2000,
    updated_at: Mocks.dates.date2000,
    paid_at: Mocks.dates.date2000,
    amount_refunded: Mocks.clare.amountZero,
    memo: null,
    due_date: Mocks.dates.date2000,
    name: Mocks.persona.full_name,
    user_id: Mocks.persona.id,
    editable: false,
    sale_transaction_id: Mocks.clare.txnId,
    can_be_refunded: true,
    non_refundable_reason: '',
    tender: Mocks.clare.tenderCard,
    label: Mocks.clare.cardLabel,
    fully_refunded: false,
    is_paid: true,
    disputed: false,
    chargeback: false,
    echeck: false,
    due_date_days_past: 0,
    upfront_payment: false,
    position: 1,
    zero_amount: false
});
